import React, { useState, useEffect } from 'react'
// adding commerce to do all the hardwork lol
import { commerce } from './lib/commerce';
import { Navbar, Products, Cart, Checkout } from './Components';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';

import Footer from './Components/Footer/Footer'
import Support from './Components/Support/Support';
import Header from './Components/Header/Header'


const App = () => {

  const [products, setProducts] = useState([]);
  const [order, setOrder] = useState({});
  const [cart, setCart] = useState({});
  const [errorMessage, setErrorMessage] = useState('');

  const fetchProducts = async () => {
    const { data } = await commerce.products.list();
    setProducts(data);
  };
  

  const fetchCart = async () => {
    // const cart = await commerce.cart.retrieve();
    // setCart(cart)
    setCart(await commerce.cart.retrieve())
  }
  // adding items to cart
  const handleAddToCart = async (productId, quantity) => {
    const { cart } = await commerce.cart.add(productId, quantity);
    setCart(cart);
  };
  // updating items in cart
  const handleUpdateCartQty = async (productId, quantity) => {
    const { cart } = await commerce.cart.update(productId, { quantity });
    setCart(cart);
  };
  // removing items
  const handleRemoveFromCart = async (productId) => {
    const { cart } = await commerce.cart.remove(productId);
    setCart(cart);
  };

  // emptying the cart
  const handleEmptyCart = async () => {
    const { cart } = await commerce.cart.empty();
    setCart(cart);
  };

  const refreshCart = async () => {
    const newCart = await commerce.cart.refresh();

    setCart(newCart);
  };

  const handleCaptureCheckout = async (checkoutTokenId, newOrder) => {
    try {
      const incomingOrder = await commerce.checkout.capture(checkoutTokenId, newOrder);

      setOrder(incomingOrder);

      refreshCart();
    } catch (error) {
      setErrorMessage(error.data.error.message);
    }
  };


  useEffect(() => {
    fetchProducts();
    fetchCart();
  }, []); 

  return (
    <Router>
      <div className="App">

        <Navbar totalItems={cart.total_items} />

         {/* <Header/> */}

          <Switch>

            <Route exact path="/">
              <Products products={products} onAddToCart={handleAddToCart} />
            </Route>

            <Route  exact path="/cart">
              <Cart cart={cart} handleUpdateCartQty={handleUpdateCartQty} handleRemoveFromCart={handleRemoveFromCart} handleEmptyCart={handleEmptyCart} />
            </Route>

            <Route exact path="/checkout">
              <Checkout cart={cart} order={order} onCaptureCheckout={handleCaptureCheckout} error={errorMessage} />
            </Route>

            

          </Switch>
          <Support/>
          <Footer/>

     </div>
    </Router>
    
  );


}

export default App;
